export var Brands;
(function (Brands) {
    Brands["WIX"] = "wix";
    Brands["EDITOR_X"] = "editorx";
})(Brands || (Brands = {}));
//# sourceMappingURL=enums.js.map